export const timeKeyEnglish = [
  "Sehri Ends",
  "Fajar",
  "Sunrise",
  "Dhuhr",
  "Asr",
  "Maghrib",
  "Isha",
];
